import React, { useMemo } from 'react'

import { useTranslation } from '../../contexts/I18nContext'
import { COLORS, THEME } from '../../styles'
import Icon from '../Icon'

import Styled from './RecipeHeading.styled'

const FEEDBACK_COUNT_MINIMUM = 5

const RecipeHeading = ({
  aggregateRating,
  author,
  className,
  description,
  hideFeedbacks,
  id,
  isLoading,
  isPreview,
  isPrivate,
  isRecipeAuthor,
  isVideoPlayed,
  onGoBack,
  source,
  title,
  totalFeedbacks,
}) => {
  const { t } = useTranslation()
  const ratingStars = useMemo(
    () => (aggregateRating ? (aggregateRating * 5).toFixed(2) : 0),
    [aggregateRating],
  )

  return (
    <Styled className={className} isVideoPlayed={isVideoPlayed}>
      {onGoBack ? (
        <Styled.goBack onClick={onGoBack}>
          <Icon
            name="arrow-left-32"
            fill={THEME.COLORS.foreground.secondary}
            width={32}
            heigh={32}
          />
        </Styled.goBack>
      ) : null}

      {isLoading ? (
        <Styled.titleSkeleton animation="wave" />
      ) : (
        <Styled.title>{title}</Styled.title>
      )}

      {source === 'user-generated' && id && isRecipeAuthor && isPrivate ? (
        <Styled.editButton to={`/profile/my-recipes/${id}`}>
          <Styled.editButtonIcon
            fill={COLORS.white}
            width={16}
            height={16}
            name="pen-pen-16"
          />
          <Styled.editButtonLabel>{t('EDIT')}</Styled.editButtonLabel>
        </Styled.editButton>
      ) : null}

      {hideFeedbacks ? null : (
        <Styled.ratingAverage href="#feedbacks">
          <Styled.ratingStars
            rating={ratingStars}
            size={18}
            id="recipe-feedback-title"
          />
          {isRecipeAuthor ? null : (
            <>
              {isLoading ? (
                <Styled.ratingCountSkeleton animation="wave" />
              ) : (
                <Styled.ratingCount>
                  {totalFeedbacks > 0 &&
                  totalFeedbacks <= FEEDBACK_COUNT_MINIMUM
                    ? t('RECIPE.GIVE_A_REVIEW')
                    : t('RECIPE.RATINGS', { count: totalFeedbacks })}
                </Styled.ratingCount>
              )}
            </>
          )}
        </Styled.ratingAverage>
      )}

      {description ? (
        <Styled.description>{description}</Styled.description>
      ) : null}

      {isPreview ? (
        <Styled.preview>{t('PREVIEW')}</Styled.preview>
      ) : author?.name ? (
        <Styled.author name={author?.name} imageUrl={author?.imageUrl} />
      ) : null}
    </Styled>
  )
}

RecipeHeading.defaultProps = {
  aggregateRating: 0,
  totalFeedbacks: 0,
}

export default RecipeHeading
